@import '../../../utils/global.module.less';

.title {
    font-size: 40px;
    font-family: LustTextMedium;
}

.header {
    width: 100%;
    border-radius: 20px;
    background-color: #f1efe9 !important;
    margin-bottom: 25px;
    border: 1px solid rgba(226, 220, 198, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.metadataContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.seperatorFields {
    margin-left: 8px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #E2DCC6 !important;
    font-size: 50px;
}
